import React, { useState } from 'react';
import propTypes from 'prop-types';
import cn from 'classnames';
import { connect } from 'react-redux';
import moment from 'moment';
import { updateList } from '~/Redux/Modules/UserLists';
import AddToFolder from '~/Components/Global/Assets/Svgs/AddToFolder';
import PinIcon from '../../../Global/Assets/Svgs/PinIcon';

const ListOption = props => {
  const {
    list,
    onChangeList,
    current,
    handleListDropDownClick,
    handleModal,
    subMenu,
    dispatchUpdateList,
  } = props;

  const clickHandler = list => {
    onChangeList(list);
    handleListDropDownClick();
    let currentDateTime = moment().format('YYYY-MM-DD HH:mm:ss');
    dispatchUpdateList({ ...list, last_opened_at: currentDateTime });
  };

  return (
    <div
      onClick={() => clickHandler(list)}
      className={cn('list-option-wrapper', list.id === current?.id ? 'current-list' : null)}
      id="target"
      role="button"
      tabIndex="0"
    >
      <PinIcon className="list-section-pin-icon" list={list} />
      <span className="list-option-title">{list.title}</span>
      <div className="list-option-icons">
        {subMenu === true && <AddToFolder list={list} handleModal={handleModal} />}
        {!subMenu && <AddToFolder list={list} handleModal={handleModal} />}
      </div>
    </div>
  );
};

ListOption.propTypes = {
  list: propTypes.object,
  current: propTypes.object,
  onChangeList: propTypes.func,
  handleListDropDownClick: propTypes.func,
  handleModal: propTypes.func,
  lowerSection: propTypes.bool,
  subMenu: propTypes.bool,
  dispatchUpdateList: propTypes.func,
};
const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => {
  return {
    dispatchUpdateList: data => dispatch(updateList(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ListOption);
